/**
 * Learner API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'
const popupApi = {
    // 나의 학습목록(get learning list)
    // http://54.251.23.221:8080/popup?type=APP
    fetpopupDetail() {
        return httpService.get(`/popup?type=APP`)
    },

        
}

// export const 
export default popupApi